/* eslint-disable react/jsx-closing-bracket-location */
// eslint-disable-next-line no-use-before-define
import React, { ChangeEvent, forwardRef, useEffect, Ref, useState } from "react";
import { TextFieldProps } from "../../../interfaces/components/form.interface";


const InputFieldComponent = forwardRef(
  (
    {
      disabled = false,
      name = "",
      id = "",
      pattern = "",
      readOnly = false,
      placeholder = "",
      required = false,
      bold = false,
      value,
      label = "",
      type = "text",
      title = "",
      Icon,
      onBlurHandler,
      onChangeHandler,
      className,
      children,
      min = 0,
    }: TextFieldProps,
    ref: Ref<HTMLInputElement>
  ) => {
    const [_value, setValue] = useState(value);
    const [isDirty, setIsDirty] = React.useState(false);

    const blurEventHandler = (event: ChangeEvent<HTMLInputElement>): void => {
      if (onBlurHandler) onBlurHandler(event);
    };

    const onFocusEventHandler = () => {
      setIsDirty(true);
    };

    const changeEventHandler = (
      event: React.ChangeEvent<HTMLInputElement>
    ): void => {
      setValue(event.currentTarget?.value);
      if (onChangeHandler) onChangeHandler(event);
    };

    // useEffect(() => {
    //   setValue(value);
    // }, [_value]);

    useEffect(() => {
      setValue(value);
    }, [value]);

    const disabledTextClasses: string = disabled
      ? "textInput__input--disabled "
      : "";

    const requiredTextClasses: string =
      Number(_value) > 0 && required && !readOnly && !disabled && isDirty
        ? "textInput__input--required "
        : "";

    const readonlyTextClasses: string = readOnly
      ? "textInput__input--readonly"
      : "";

    const patternString = pattern instanceof RegExp ? pattern.source : pattern;

    return (
      <div className={`textInput__wrapper `} data-test='inputField-wrapper'>
        {label && bold && (
          <label
            htmlFor={id}
            className='textInput__label flex items-center flex-row'
            data-test='inputField-label'>
            <b>{Icon && <Icon className="w-4 h-4 mr-2" />} {label}</b>
          </label>
        )}

        {label && !bold && (
          <label
            htmlFor={id}
            className='textInput__label flex items-center flex-row'
            data-test='inputField-label'>
            {Icon && <Icon className="w-4 h-4 mr-2" />} {label}
          </label>
        )}

        <input
          data-test='inputField-input'
          className={`textInput__input ${readonlyTextClasses} ${requiredTextClasses} ${disabledTextClasses} ${className}`}
          disabled={disabled}
          id={id}
          name={name}
          ref={ref}
          onBlur={blurEventHandler}
          onChange={changeEventHandler}
          onFocus={onFocusEventHandler}
          pattern={patternString}
          placeholder={placeholder}
          readOnly={readOnly}
          required={required}
          type={type}
          value={_value}
          title={title}
        />
        {children}
      </div>
    );
  }
);

InputFieldComponent.displayName = "InputFieldComponent";

export default InputFieldComponent;
